import { FC, memo, PropsWithChildren } from "react";
import "./panel-title.scss";

interface PanelTitlerops extends PropsWithChildren {
  className?: string;
  style?: React.CSSProperties;
}
const PanelTitleComponent: FC<PanelTitlerops> = ({ className = "", children, ...restProps }) => {
  return (
    <h3 className={`panel-title text-black ${className}`} {...restProps}>
      {children}
    </h3>
  );
};

export const PanelTitle = memo(PanelTitleComponent);
